import { render, staticRenderFns } from "./AllTaskHistory.vue?vue&type=template&id=4493f154&scoped=true&"
import script from "./AllTaskHistory.vue?vue&type=script&lang=js&"
export * from "./AllTaskHistory.vue?vue&type=script&lang=js&"
import style0 from "./AllTaskHistory.vue?vue&type=style&index=0&id=4493f154&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4493f154",
  null
  
)

export default component.exports